<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,0.9999999403953552C15,0.9999999403953552,1,0.9999999403953552,1,0.9999999403953552C0.45,0.9999999403953552,0,1.4499999403953552,0,1.9999999403953552C0,1.9999999403953552,0,13.999999940395355,0,13.999999940395355C0,14.549999940395356,0.45,14.999999940395355,1,14.999999940395355C1,14.999999940395355,15,14.999999940395355,15,14.999999940395355C15.55,14.999999940395355,16,14.549999940395356,16,13.999999940395355C16,13.999999940395355,16,1.9999999403953552,16,1.9999999403953552C16,1.4499999403953552,15.55,0.9999999403953552,15,0.9999999403953552C15,0.9999999403953552,15,0.9999999403953552,15,0.9999999403953552ZM4,12.999999940395355C4,12.999999940395355,2,12.999999940395355,2,12.999999940395355C2,12.999999940395355,2,2.9999999403953552,2,2.9999999403953552C2,2.9999999403953552,4,2.9999999403953552,4,2.9999999403953552C4,2.9999999403953552,4,12.999999940395355,4,12.999999940395355C4,12.999999940395355,4,12.999999940395355,4,12.999999940395355ZM7,12.999999940395355C7,12.999999940395355,5,12.999999940395355,5,12.999999940395355C5,12.999999940395355,5,2.9999999403953552,5,2.9999999403953552C5,2.9999999403953552,7,2.9999999403953552,7,2.9999999403953552C7,2.9999999403953552,7,12.999999940395355,7,12.999999940395355C7,12.999999940395355,7,12.999999940395355,7,12.999999940395355ZM14,12.999999940395355C14,12.999999940395355,8,12.999999940395355,8,12.999999940395355C8,12.999999940395355,8,2.9999999403953552,8,2.9999999403953552C8,2.9999999403953552,14,2.9999999403953552,14,2.9999999403953552C14,2.9999999403953552,14,12.999999940395355,14,12.999999940395355C14,12.999999940395355,14,12.999999940395355,14,12.999999940395355Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ColumnLayout',
} as DefineComponent
</script>
